import React from 'react';
import './ProjectDetail.css';

export function ProjectFullWidth({ image, alt, caption, children }) {
  return (
    <div className="project-detail-section">
      <div className="project-detail-centered-img">
        <img src={image} alt={alt} className="project-detail-full-width-img" />
        {caption && <p className="project-detail-img-caption">{caption}</p>}
      </div>
      <div className="project-detail-text">
        {children}
      </div>
    </div>
  );
}

export function ProjectSideBySide({ image, alt, caption, children }) {
  return (
    <div className="project-detail-section side-by-side">
      <div className="project-detail-centered-img">
        <img src={image} alt={alt} className="project-detail-inline-img" />
        {caption && <p className="project-detail-img-caption">{caption}</p>}
      </div>
      <div className="project-detail-text">
        {children}
      </div>
    </div>
  );
}

export function ProjectSideBySideReverse({ image, alt, caption, children }) {
  return (
    <div className="project-detail-section side-by-side side-by-side-reverse">
      <div className="project-detail-text">
        {children}
      </div>
      <div className="project-detail-centered-img">
        <img src={image} alt={alt} className="project-detail-inline-img" />
        {caption && <p className="project-detail-img-caption">{caption}</p>}
      </div>
    </div>
  );
}

export function ProjectFooter({ title, description, resources, collaborators, backgroundImage }) {
  return (
    <footer className="project-footer">
      {backgroundImage && (
        <>
          <img src={backgroundImage} alt="" className="project-footer-bg" />
          <div className="project-footer-overlay"></div>
        </>
      )}
      <div className="project-footer-content">
        <div className="project-footer-section">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        {resources && resources.length > 0 && (
          <div className="project-footer-section">
            <h3>Resources</h3>
            <ul>
              {resources.map((resource, index) => (
                <li key={index}>
                  <a href={resource.url} target="_blank" rel="noopener noreferrer">
                    {resource.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
        {collaborators && collaborators.length > 0 && (
          <div className="project-footer-section">
            <h3>Collaborators</h3>
            <ul>
              {collaborators.map((collaborator, index) => (
                <li key={index}>
                  <a href={collaborator.url} target="_blank" rel="noopener noreferrer">
                    {collaborator.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="project-footer-bottom">
        <p>&copy; {new Date().getFullYear()} Luke Fiorante. All rights reserved.</p>
      </div>
    </footer>
  );
} 